import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { lastValueFrom } from 'rxjs';
import { AccountStateService } from './state/account-state.service';
import { EnvironmentService } from '../environment/environment.service';

@Injectable({ providedIn: 'root' })
export class AccountService {
  private http = inject(HttpClient);
  private environmentService = inject(EnvironmentService);
  private accountStateService = inject(AccountStateService);

  private readonly resourceUrl: string;

  constructor() {
    this.resourceUrl = this.environmentService.getApiUrl() + 'api/account';
  }

  async hasBSKWECAccess(): Promise<boolean> {
    if (this.accountStateService.isBskwUser == undefined) {
      try {
        const responseBSKWECAccess = await lastValueFrom(this.http.get<void>(this.resourceUrl + '/bskw/verify', { observe: 'response' }));
        if (responseBSKWECAccess.status === 200) {
          this.accountStateService.isBskwUser = true;
        }
      } catch (err) {
        if (err.status === 404) {
          this.accountStateService.isBskwUser = false;
        }
      }
    }
    return this.accountStateService.isBskwUser === true;
  }
}
